/**
 * The only place in src/telemetry that touches the timer globals (enforced by .eslintrc.cjs).
 * A slot holds at most one pending timeout: arming it clears the previous one first.
 */
export class TimerSlot {
  private handle: ReturnType<typeof setTimeout> | null = null;

  arm(fn: () => void, delayMs: number): void {
    this.clear();
    this.handle = setTimeout(() => {
      this.handle = null;
      fn();
    }, delayMs);
  }

  clear(): void {
    if (this.handle !== null) {
      clearTimeout(this.handle);
      this.handle = null;
    }
  }

  isArmed(): boolean {
    return this.handle !== null;
  }
}
